import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

export const inputClasses = "w-full min-w-0 rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground outline-none placeholder:text-muted-foreground transition-[border-color,box-shadow] focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/15 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/15";

export function Input({ className, type = "text", ...props }: ComponentProps<"input">) {
  const nativeControl = ["checkbox", "radio", "range", "file", "hidden", "color"].includes(type);
  return <input data-slot="input" type={type} className={cn(!nativeControl && inputClasses, !nativeControl && "h-9", className)} {...props} />;
}
